<template>
    <CommonPopupFrame :isOpen="isShowPopup" :closeCompleteAction="closeCompleteAction" :changeHeight="353" :changeHeightUnit="'px'" :changeBottom="0">
        <template v-if="type === MODAL_TYPE.START || type === MODAL_TYPE.START_PC">
            <div style="padding: 0 12px;">
                <div style="width: 36px; height: 5px; background-color: #d9d9d9; border-radius: 5px; margin: 0 auto; margin-top: 5px;"></div>
                <div style="margin-top: 26px; font-size: 32px; font-weight: 700;">시작하기</div>
                <div style="margin-top: 20px;">
                    <div style="height: 56px; display: flex; justify-content: center; align-items: center; position: relative; border-radius: 12px; background-color: #f5f5f5; " @click="signupEmail">
                        <div style="position: absolute; left: 22px; top: 50%; transform: translateY(-50%);">
                            <img style="width: 20px;" :src="require('@/assets/img/splash_logo.png')" alt="">
                        </div>
                        <div style="font-weight: 500; font-size: 14px;">이메일로 시작하기</div>
                    </div>
                    <div style="font-size: 14px;font-weight: 500;line-height: 24px; margin-top: 8px; text-align: center;">또는</div>
                    <div style="display: flex; gap: 8px; margin-top: 20px;">
                        <div @click="loginSns(each.id)" v-for="each, i in snsList" :key="i" style="flex: 1;">
                            <div :style="{ backgroundColor: each.backgroundColor }" style="border-radius: 33px; display: flex; height: 56px; justify-content: center; align-items: center;">
                                <img :style="{ width: each.imgWidth + 'px' }" :src="each.imgPath" alt="">
                            </div>
                        </div>
                    </div>
                    <div style="text-align: center; margin-top: 32px;">
                        <!-- <div @click="showLoginPopup" style="font-weight: 500;line-height: 24px;">이미 계정이 있나요? <span style="color: var(--color-main);">로그인하기</span></div> -->
                        <div style="font-size: 10px;font-weight: 400; line-height: 24px; margin-top: 44px; color: #606060;">로그인 및 가입 시 사커하우의 <span style="color: var(--color-main);">이용약관, 개인정보 보호 정책</span>에 동의하게 됩니다.</div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="MODAL_TYPE.LOGIN">
            <div style="padding: 0 12px;">
                <div style="width: 36px; height: 5px; background-color: #d9d9d9; border-radius: 5px; margin: 0 auto; margin-top: 5px;"></div>
                <div style="margin-top: 26px; font-size: 32px; font-weight: 700;">로그인</div>
                <div style="margin-bottom: 4px; margin-top:20px;">
                    <div style="display: flex; justify-content: space-between; font-weight: 500; font-size: 14px; margin-bottom: 8px;">
                        <div>사커하우 계정</div>
                    </div>
                    <div>
                        <div style="position: relative; z-index: 10; border-bottom: 1px solid #ebebeb;">
                            <input v-model="id" placeholder="이메일을 입력하세요" class="common_box active_email" style="outline: none; width: 100%; border: none;">
                        </div>
                        <div style="transition: all 0.3s; position: relative; z-index: 1;">
                            <input v-model="password" type="password" placeholder="비밀번호를 입력하세요" class="common_box active_password" style="outline: none; width: 100%; border: none;">
                        </div>
                    </div>
                </div>
                <div :style="{ backgroundColor: id.length !== 0 && password.length !== 0 ? '#210f03' : '#f5f5f5', color: id.length !== 0 && password.length !== 0 ? '#fff' : '#d9d9d9' }" @click="login" style="text-align: center; font-size: 14px; line-height: 24px;" class="common_box">계속하기</div>
                <div style="font-size: 14px;font-weight: 500;line-height: 24px; margin-top: 8px; text-align: center;">또는</div>
                <div style="display: flex; gap: 8px; margin-top: 20px;">
                    <div @click="loginSns(each.id)" v-for="each, i in snsList" :key="i" style="flex: 1;">
                        <div :style="{ backgroundColor: each.backgroundColor }" style="border-radius: 33px; display: flex; height: 56px; justify-content: center; align-items: center;">
                            <img :style="{ width: each.imgWidth + 'px' }" :src="each.imgPath" alt="">
                        </div>
                    </div>
                </div>
                <div style="text-align: center; margin-top: 32px;">
                    <div @click="showFindAccount" style="font-weight: 500;line-height: 24px;">계정을 잊어버렸나요? <span style="color: var(--color-main);">전화번호로 계정찾기</span></div>
                    <!-- <div style="font-size: 10px;font-weight: 400; line-height: 24px; margin-top: 44px; color: #606060;">로그인 및 가입 시 사커하우의 <span style="color: var(--color-main);">이용약관, 개인정보 보호 정책</span>에 동의하게 됩니다.</div> -->
                </div>
            </div>
        </template>
    </CommonPopupFrame>
</template>

<script>
import CommonPopupFrame from "@/components/modal/my/CommonPopupFrame"
import { LOGIN_PLATFORM } from "../../Constants";
const MODAL_TYPE = {
    LOGIN: "LOGIN",
    START: "START",
    START_PC: "START_PC"
}
const SNS_ID = {
    KAKAO: "KAKAO",
    NAVER: "NAVER",
    APPLE: "APPLE",
    GOOGLE: "GOOGLE"
}

export default {
    name: 'StratLoginPopup',
    components: { CommonPopupFrame },
    data() {
        return {
            MODAL_TYPE: MODAL_TYPE,
            snsList: [
                { id: SNS_ID.KAKAO, backgroundColor: '#FFDA3A', imgPath: require('@/assets/img/kakao.png'), imgWidth: 24 },
                { id: SNS_ID.NAVER, backgroundColor: '#03CF5D', imgPath: require('@/assets/img/naver.png'), imgWidth: 20 },
                { id: SNS_ID.APPLE, backgroundColor: '#210F03', imgPath: require('@/assets/img/apple.png'), imgWidth: 19 },
                { id: SNS_ID.GOOGLE, backgroundColor: '#F5F5F5', imgPath: require('@/assets/img/google.png'), imgWidth: 24 },
            ],
            SNS_ID: SNS_ID,
            id: '',
            password: '',
            is_show_social: false,
            isShowPopup: false,
            type: MODAL_TYPE.START_PC
        }
    },
    props: {
        changeType: {
            type: Function,
            default: () => { }
        },
    },
    computed: {
        isIOS() {
            const device = this.$cookies.get('device');
            return device === 'ios';
        }
    },
    methods: {
        closeCompleteAction() {
            this.isShowPopup = false
            setTimeout(() => {
                this.$GlobalStore.closeLastModal()
            }, 500);
        },
        showIcon(sosialId) {
            if (sosialId === SNS_ID.APPLE) {
                if (this.isIOS) {
                    return true
                } else {
                    return false
                }
            }
            return true
        },
        showFindAccount() {
            this.$GlobalStore.addModal('FindAccount', { transitionName: 'bottom', isModalBackTransparent: true, completeAction: this.changeType });
        },
        signupSns() {
            window.open('http://localhost:8063/login/kakao/form')
            // window.open('/login/kakao/form')
        },
        loginSns(snsType) {
            if (snsType === SNS_ID.KAKAO) {
                this.loginKaKao()
            } else if (snsType === SNS_ID.NAVER) {
                this.loginNaver()
            } else if (snsType === SNS_ID.APPLE) {
                this.loginApple()
            } else if (snsType === SNS_ID.GOOGLE) {
                this.loginGoogle()
            }
        },
        signupEmail() {
            this.$GlobalStore.addModal('MemberRegist', {});
        },
        async loginKaKao() {
            const device = this.$cookies.get('device');

            if (device === 'android') {
                this.$GlobalStore.addModal('KaKaoLogin', { transitionName: '' });
            } else if (device === 'ios') {
                // const isInstalled = await KaKaoLoginManager.getKaKaoInstalled();
                // if(isInstalled){
                this.$GlobalStore.addModal('KaKaoLogin', { transitionName: '' });
                // }else {
                //     this.$GlobalStore.showAlert('카카오 로그인은 카카오톡 설치가 필요합니다.');
                // }
            } else {
                // const userAgent = navigator.userAgent;
                // if (userAgent.match(/iPhone|iPad|iPod|KAKAOTALK/i)) {
                window.open(this.$apiPath + 'login/kakao/form')
                // window.open('http://localhost:8063/login/kakao/form')
                // }else {
                //     this.$GlobalStore.addModal('KaKaoLogin', { transitionName: '' });
                // }
            }

        },
        async loginNaver() {
            const device = this.$cookies.get('device');
            let pushToken = '';
            let uuid = '';
            if (device === 'android' || device === 'ios') {
                pushToken = await window.pushCustomManager.getPushToken();
                uuid = await window.pushCustomManager.getUuid();
            }

            const query = "?pushToken=" + pushToken + '&uuid=' + uuid;

            let domain = '';
            //TODO 테스트 할때만 주석풀어서 사용.
            // domain = 'http://192.168.0.203:8060';

            if (device === 'ios') {
                const url = (domain ? domain : location.origin) + "/login/naver/form" + query;

                /*eslint-disable no-undef */
                webkit.messageHandlers.ios.postMessage({ cmd: 'showWebView', url: url });
            } else {
                const url = domain + "/login/naver/form" + query;
                window.open(url);
            }
        },
        async login() {
            const parameters = {};
            parameters.id = this.id;
            parameters.password = this.password;
            const device = this.$cookies.get('device');
            if (device === 'android' || device === 'ios') {
                parameters.pushToken = await window.pushCustomManager.getPushToken();
                parameters.uuid = await window.pushCustomManager.getUuid();
            }

            parameters.marketingAgree = localStorage.getItem('marketing_agree') ?? '';

            const res = await this.$Axios.post('/api/login', parameters);

            if (res.data.code === 0) {
                localStorage.removeItem('marketing_agree');
                this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                this.completeAction(res.data.isSoccerhowWritten, res.data.loginInfo)
            } else {
                alert(res.data.msg);
            }

        },
        async loginGoogle() {
            const device = this.$cookies.get('device');
            let pushToken = '';
            let uuid = '';
            if (device === 'android' || device === 'ios') {
                pushToken = await window.pushCustomManager.getPushToken();
                uuid = await window.pushCustomManager.getUuid();
            }

            const query = "?pushToken=" + pushToken + '&uuid=' + uuid;

            let domain = '';
            //TODO 테스트 할때만 주석풀어서 사용.
            // domain = 'http://ubiplus.iptime.org:8001';

            if (device === 'ios') {
                const url = (domain ? domain : location.origin) + "/login/google/form" + query;

                /*eslint-disable no-undef */
                webkit.messageHandlers.ios.postMessage({ cmd: 'showWebView', url: url });
            } else {
                const url = domain + "/login/google/form" + query;
                window.open(url);
            }
        },
        async loginApple() {
            /*eslint-disable no-undef */
            webkit.messageHandlers.ios.postMessage({ cmd: 'loginApple' });
        },
    },
    created() {
        setTimeout(() => {
            this.isShowPopup = true
        }, 100);

        window.loginApple = async (id) => {
            const parameters = {};
            parameters.id = id;

            const device = this.$cookies.get('device');
            if (device === 'android' || device === 'ios') {
                parameters.pushToken = await window.pushCustomManager.getPushToken();
                parameters.uuid = await window.pushCustomManager.getUuid();
            }

            parameters.marketingAgree = localStorage.getItem('marketing_agree') ?? '';

            const res = await this.$Axios.post('/login/apple', parameters);
            if (res.data.code === 0) {
                localStorage.removeItem('marketing_agree');
                this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                this.$GlobalStore.closeLastModal(true);
                await this.$Util.checkAfterLogin(res.data.isSoccerhowWritten);

            } else if (res.data.code === 1) {
                this.$GlobalStore.addModal('KaKaoRegist', { id: id, mode: LOGIN_PLATFORM.APPLE });
            } else {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        }

        const is_show_social = this.$cookies.get('is_show_social');

        if (is_show_social === '1') {
            const device = this.$cookies.get('device');
            if (device === 'android' || device === 'ios') {
                const app_version = this.$cookies.get('appv');
                if (!app_version) return;

                let is_apply = false;

                if (device === 'ios') {
                    is_apply = parseInt(app_version) >= 26;
                } else if (device === 'android') {
                    is_apply = parseInt(app_version) >= 17;
                }

                if (is_apply) this.is_show_social = true;
            } else {
                this.is_show_social = true;
            }
        }

        if (!this.isIOS) {
            this.snsList.splice(2, 1)
        }
    }
}
</script>

<style scoped>
.common_box {
    padding: 12px;
    background-color: #f5f5f5;
    border-radius: 12px;
}

.active_email {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0
}

.active_password {
    border-top-left-radius: 0;
    border-top-right-radius: 0
}
</style>